function Button({ text, state, onClick }) {
  if (state === "selectable") {
    return (
      <button
        className="px-8 py-3 text-center border-2 rounded-full border-blue text-blue hover:text-white hover:bg-blue"
        type="button"
        onClick={onClick}
      >
        {text}
      </button>
    );
  }
  if (state === "correct") {
    return (
      <button
        className="px-8 py-3 text-center text-white bg-green-600 border-2 border-green-600 rounded-full"
        type="button"
        disabled
      >
        {text}
      </button>
    );
  }
  if (state === "correctOther") {
    return (
      <button
        className="px-8 py-3 text-center text-green-600 border-2 border-green-600 rounded-full"
        type="button"
        disabled
      >
        {text}
      </button>
    );
  }
  if (state === "wrong") {
    return (
      <button
        className="px-8 py-3 text-center text-white bg-red-600 border-2 border-red-600 rounded-full"
        type="button"
        disabled
      >
        {text}
      </button>
    );
  }

  if (state === "other") {
    return (
      <button
        className="px-8 py-3 text-center border-2 rounded-full border-secondary text-secondary"
        type="button"
        disabled
      >
        {text}
      </button>
    );
  }

  if (state === "selectable") {
    return (
      <button
        className="px-8 py-3 text-center border-2 rounded-full border-blue text-blue hover:text-white hover:bg-blue"
        type="button"
      >
        {text}
      </button>
    );
  }
}

export default Button;
